/* src/app/app.component.scss */
.content {
  padding: 16px 15px 0px 80px;
}
.content-new {
  padding: 0;
}
.content-pt0 {
  padding-top: 15px !important;
}
.content-webbtree-freemium {
  padding: 0px 16px 0px 16px;
}
.content-webbtree-freemium2 {
  padding: 0px 16px 0px 16px;
}
/*# sourceMappingURL=app.component-KD4PXVRQ.css.map */
